import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 2rem;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #333;
  line-height: 1;
`;

const FileFrame = styled.iframe`
  width: 85vw;
  height: 85vh;
  border: none;
`;

const FileImage = styled.img`
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
`;

const FileVideo = styled.video`
  max-width: 100%;
  max-height: 85vh;
`;

const FileViewerModal = ({ file, onClose }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error] = useState(null); // setError was unused, so we can remove the setter.
  // Assuming useAuth provides the token. If not, you might need to pass it as a prop.
  useAuth(); // We call this to ensure the component is within the auth context, but we don't need the token here.

  useEffect(() => {
    if (!file) return;

    setBlobUrl(file.url);
    setLoading(false);
  }, [file]);

  if (!file) return null;

  const renderFile = () => {
    if (file.type === 'text') {
      return <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', padding: '2rem', maxHeight: '80vh', overflowY: 'auto', textAlign: 'left' }}>{file.content}</pre>;
    }

    if (loading) return <p style={{ padding: '2rem' }}>Loading secure file...</p>;
    if (error) return <p style={{ padding: '2rem', color: 'red' }}>{error}</p>;
    if (!blobUrl) return <p style={{ padding: '2rem' }}>No URL available.</p>;

    const mime = file.mimetype?.toLowerCase() || '';

    if (mime.includes('pdf')) return <FileFrame src={blobUrl} title="File Viewer" />;
    if (mime.includes('image') || blobUrl.includes('.jpg') || blobUrl.includes('.png')) return <FileImage src={blobUrl} alt="Document Preview" />;
    if (mime.includes('video') || blobUrl.includes('.mp4') || blobUrl.includes('.webm')) return <FileVideo src={blobUrl} controls autoPlay />;

    return <p style={{ padding: '2rem' }}>Cannot preview this file type. <a href={blobUrl} target="_blank" rel="noopener noreferrer">Download it here</a>.</p>;
  };

  return (
    <ModalBackdrop onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}><FaTimes /></CloseButton>
        {renderFile()}
      </ModalContent>
    </ModalBackdrop>
  );
};

export default FileViewerModal;